<template>
  <html>
    
  <div style="margin-top:20px;">
    <body>
    <div class="container">
   
    <div class="row">
    <div class="col-12">
    
      <div class="card border-primary shadow rounded mt-3" style="max-width: 600px;">
          
        <div style="background-color:white" class="card-header border border-primary text-white mb-1">
          
         <img class="float-right " src="@/assets/logo_retail1.jpg" alt="" height="150" width="350"> 
                   
        </div>
                 
        <div class="card-body" >
        
        <form v-on:submit.prevent="submit()">
          
          <div class="form-group">
          <label for="username"><strong>User ID</strong></label>
          <div class="input-group mb-2">
           <div class="input-group-prepend">
            <div class="input-group-text"><i class='fas fa-user-alt'></i></div>
          </div>
          <input v-focus autocomplete="off" v-model="username" required type="text" class="form-control" id="userId"  placeholder="Utente">
          </div>
          </div>
           <label for="password"><strong>Password</strong></label>
          <div class="form-group">
            <div class="input-group mb-2">
           <div class="input-group-prepend">
          <div class="input-group-text">
            <i class='fas fa-lock-open'></i>
          </div>
        </div> 
          
          <input autocomplete="off" v-model="password" required type="password" class="form-control" id="password" placeholder="Password">
            </div>
          </div>
          <button  :disabled="spinner" type="submit" class="btn btn-primary mb-2 float-right mr-3">
            
            <i  class="fas fa-sign-in-alt mr-2" aria-hidden="true"></i>
            LOGIN
            <span v-if="spinner"  class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
          </button>

        
          <alert-box @close="msg.title=''" v-bind:msg="msg"  ></alert-box>

        </form>  

        
        </div>

     
        <div v-if="1==0" class="card-footer text-center">
          <a   href="#">
            
            <img  src="https://d0.awsstatic.com/logos/powered-by-aws.png"  height="30px" alt="Powered by AWS Cloud Computing">
          </a>
          
        </div>
      



      </div>
      </div>

   
  
   </div>
  
   </div>
  
  
  

</body>
</div>
  
  
  </html>
</template>

<script>
import axios              from 'axios';
import alertBox from '@/components/common/AlertBox.vue';
export default {
  components: {alertBox},
   data () {
    return {

     
      username : '',
      password : '',   
      spinner  : false,
     
      msg : {
        title : '',
        body  : '',
        type  : 0
      }
    }
    
    
    },
   watch: {

    },
    directives: 
    {
      focus: {
      
        inserted: function (el) {
          
          el.focus()
          }
           
       
      }
    },
    created()
    {
        //localStorage.removeItem("deskId")
        localStorage.removeItem('cart')
        localStorage.removeItem('barcode')
        localStorage.removeItem('customer')   

       this.$store.commit('AUTH_STATUS_CHANGE',{isLoggedIn : false}) 
       this.$store.commit('AUTH_STORE_ID',{storeId: 0})
       
    },
    methods:{

      submit()
      {
      
        this.msg.title = ''
        this.spinner  = true  
        
        const url       = process.env.VUE_APP_ROOT_API + "api/sp/login"        
        const data      = {'username' : this.username}
        const sp        = {'sp'       : 'spLogin'}
        const json      = Object.assign(data, sp);
    
        axios({
        url    : url,
        method : "post",
        data   : json
        
        })
        .then(res => {
                    

          if(res.data.recordsets[0].length > 0)
          {

            var userId       = res.data.recordsets[0][0].userId
            
            var password     = res.data.recordsets[0][0].password
            var isAdmin      = res.data.recordsets[0][0].isAdmin
            var companyId    = res.data.recordsets[0][0].companyId
            var isLocked     = res.data.recordsets[0][0].isLocked
            var url_img      = res.data.recordsets[0][0].img_url
            var img_num      = res.data.recordsets[0][0].img_num
            var token        = res.data.token
            var printer_type = res.data.recordsets[0][0].printer_type
            var vat          = res.data.recordsets[0][0].vat
            var shopify      = res.data.recordsets[0][0].shopify

            
           
            if(isLocked == 1)
            {
              
              this.msg.title = "*** ATTENZIONE *** "
              this.msg.body  = 'Utente non abilitato.'
              this.msg.type  = 1
              return
            }
            if(this.password != password)
            {
             
              this.msg.title = "*** ATTENZIONE *** "
              this.msg.body  = 'Password non valida.'
              this.msg.type  = 1
              return
            }


          }
          else
          {
             
              this.msg.title = "*** ATTENZIONE *** "
              this.msg.body  = 'Utente o password non validi.'
              this.msg.type  = 1
              return
          }

          const userMenu = res.data.recordsets[1]
          this.$store.commit('SET_COMPANY',{reset:false,Id:companyId,printer_type:printer_type,vat:vat,'shopify':shopify}) 
          this.$store.commit('SET_COMPANY_URL_IMG',{url:url_img,num:img_num}) 
          this.$store.commit('AUTH_STATUS_CHANGE',{userId:userId, isLoggedIn : true,currentUser : this.username,isAdmin:isAdmin,token:token,userMenu:userMenu}) 
          this.$router.push('/store')

        })
        .catch(err => {
              //console.log(err)
              
              if(err.response)
              {
                
                this.msg.title = 'ATTENZIONE *'
                this.msg.body  = err.response.statusText
                this.msg.type  = 1
              
               
              }
              else 
              {
               
                this.msg.title = 'ATTENZIONE **'
                this.msg.body  = err
                this.msg.type  = 1
              
              }
              return
        
        
        
        })
        .finally(() => {
          this.spinner = false
         
        });
      }
    },  
 
}

</script>
<style scoped>

.img_center{
  text-align: center;
}
.studio1
{
  
 font-style: oblique; 
 font-family : "Roboto Condensed";
 /*color       : "cornflowerblue";*/
 font-size   : 25px;
 
   
}
.studio2
{
  color       :rgb(10, 216, 20);
  /*color       :#93FF33; */
  font-size   : 32px;
  font-family : "Roboto Condensed";
  
  
}

body{


background-image: linear-gradient(rgba(255,0,0,0), rgba(2, 12, 72, 0.826));
background-size: cover;
background-repeat: no-repeat;
height: 100vh;


}
/*
.container{
height: 100%;
align-content: center;
}
*/
.input-group-text{
  background-color: white;
}


.card{



background-color: rgba(0,0,0,0.10) !important;
}

.span1 {
  text-decoration: underline;
}
</style>